import axios from "axios";
import { Component } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";

export default class DeliveryChallanView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      projects: [],
      purchaseOrders: [],
      poItems: [],
      dcNumber: "",
      dcDate: "",
      customerId: "",
      projectId: "",
      purchaseOrderId: "",
      status: "pending",
      loading: true,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      errors: {},
      isEdit: false,
      dcId: null,
      color: ''
    };
  }

  componentDidMount() {
    this.fetchCustomers();
    const dcId = this.props.match?.params?.id;
    console.log("dcId", dcId)
    if (dcId) {
      this.setState({ isEdit: true, dcId });
      this.fetchDeliveryChallan(dcId);
    }
  }

  fetchCustomers = () => {
    axios
      .get("/customer")
      .then((res) => {
        this.setState({ customers: res.data, loading: false });
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchProjects = (customerId) => {
    axios
      .get(`/project/customer/${customerId}`)
      .then((res) => {
        this.setState({ projects: res.data, loading: false });
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchPurchaseOrders = (customerId, projectId) => {
    axios
      .get(`/purchaseOrders/${customerId}/${projectId}`)
      .then((res) => {
        this.setState({
          purchaseOrders: res.data,
          loading: false
        });
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchPoItems = (purchaseOrderId) => {
    // debugger;
    axios
      .get(`/purchaseOrders/${purchaseOrderId}`)
      .then((res) => {
        console.log("res.data.items", res.data.items)
        this.setState({
          poItems: res.data.items.map((item) => ({
            purchaseOrderItemId: item.id,
            serialNumber: item.serialNumber,
            itemName: item.item.name,
            askedQuantity: item.quantity,
            pendingQuantity: item.pendingQuantity,
            uom: item.uom,
            quantity: 0,
            loading: false
          })),
        });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchDeliveryChallan = (id) => {
    axios
      .get(`/deliveryChallans/view/${id}`)
      .then((res) => {
        const dc = res.data;
        console.log(" dc.items", dc.items)
        this.setState({
          dcNumber: dc.dcNumber,
          dcDate: dc.dcDate,
          customerId: dc.customerId,
          projectId: dc.projectId,
          purchaseOrderId: dc.purchaseOrderId,
          status: dc.status,
          poItems: dc.items.map((item) => ({
            purchaseOrderItemId: item.purchaseOrderItemId,
            //itemName: item.purchaseOrderItem?.itemId,
            itemName: item.purchaseOrderItem?.item?.name,
            askedQuantity: item.purchaseOrderItem.quantity,
            serialNumber: item.purchaseOrderItem.serialNumber,
            pendingQuantity: item.purchaseOrderItem.pendingQuantity,
            uom: item.uom,
            remark: item.remark,
            quantity: item.quantity,
          })),
        }, () => {
          // These will run after state is updated
          this.fetchProjects(dc.customerId);
          this.fetchPurchaseOrders(dc.customerId, dc.projectId);
          setTimeout(() => {
            this.setState({ loading: false });
          }, 900);
        });
      })
      .catch((err) => {
        console.error("Error fetching delivery challan:", err);
        this.setState({
          showToast: true,
          toastMessage: "Failed to load delivery challan data",
          toastVariant: "danger",
          color: 'red'
        });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };
  // fetchDeliveryChallan = (id) => {

  //   axios
  //     .get(`/deliveryChallans/${id}`)
  //     .then((res) => {
  //       debugger;
  //       const dc = res.data;
  //       console.log("dc", dc)
  //       this.setState(
  //         {
  //           dcNumber: dc.dcNumber,
  //           dcDate: dc.dcDate,
  //           customerId: dc.customerId,
  //           projectId: dc.projectId,
  //           purchaseOrderId: dc.purchaseOrderId,
  //           status: dc.status,
  //           poItems: dc.items.map((item) => ({
  //             purchaseOrderItemId: item.purchaseOrderItemId,
  //             itemName: item.purchaseOrderItem.item.name,
  //             askedQuantity: item.purchaseOrderItem.quantity,
  //             pendingQuantity: item.purchaseOrderItem.pendingQuantity,
  //             uom: item.uom,
  //             quantity: item.quantity,
  //           })),
  //         },
  //         () => {
  //           this.fetchProjects(dc.customerId);
  //           this.fetchPurchaseOrders(dc.customerId, dc.projectId);
  //         }
  //       );
  //     })
  //     .catch((err) => {
  //       console.log("error", err)
  //     });
  // };

  handleCustomerChange = (e) => {
    const customerId = e.target.value;
    this.setState(
      {
        customerId,
        projectId: "",
        purchaseOrderId: "",
        projects: [],
        purchaseOrders: [],
        poItems: [],
      },
      () => {
        if (customerId) {
          this.fetchProjects(customerId);
        }
      }
    );
  };

  handleProjectChange = (e) => {
    const projectId = e.target.value;
    this.setState(
      {
        projectId,
        purchaseOrderId: "",
        purchaseOrders: [],
        poItems: [],
      },
      () => {
        if (this.state.customerId && projectId) {
          this.fetchPurchaseOrders(this.state.customerId, projectId);
        }
      }
    );
  };

  handlePurchaseOrderChange = (e) => {
    const purchaseOrderId = e.target.value;
    this.setState({ purchaseOrderId, poItems: [] }, () => {
      if (purchaseOrderId) {
        this.fetchPoItems(purchaseOrderId);
      }
    });
  };

  handlePoItemQuantityChange = (index, value) => {
    const poItems = [...this.state.poItems];
    const quantity = parseFloat(value);
    if (isNaN(quantity) || quantity < 0) return;
    if (quantity > poItems[index].pendingQuantity) {
      this.setState({
        showToast: true,
        toastMessage: "Quantity cannot be more than pending quantity",
        toastVariant: "danger",
        color: 'red'
      });
      return;
    }
    poItems[index].quantity = quantity;
    this.setState({ poItems });
  };



  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/DeliveryChallanList");
      this.setState({ loading: false });
    }, 500);
  }

  deliveryChallanList = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/DeliveryChallanList");
      this.setState({ loading: false });
    }, 500);
  }

  render() {
    const {
      customers,
      projects,
      purchaseOrders,
      poItems,
      dcNumber,
      dcDate,
      poDate,
      customerId,
      projectId,
      purchaseOrderId,
      status,
      errors,
      loading,
      isEdit,
    } = this.state;

    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            <Card>
              <Card.Header>
                <div className="purchase-order-back">
                  <b> View Delivery Challan
                  </b>
                  <span style={{ cursor: 'pointer' }} onClick={() => this.deliveryChallanList()}>
                    <i className="far fa-arrow-alt-circle-right"> Delivery Challan List</i>
                  </span>
                </div>
              </Card.Header>
              <Card.Body>
                <Form >
                  <Row>
                    <Col md={3}>
                      <Form.Group controlId="formCustomer">
                        <Form.Label className="required">Customer</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={customerId}
                          onChange={this.handleCustomerChange}
                          isInvalid={!!errors?.customerId}
                          disabled
                        >
                          <option value="">Select Customer</option>
                          {customers.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.customerId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formProject">
                        <Form.Label className="required">Project</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={projectId}
                          // onChange={this.handleProjectChange}
                          // isInvalid={!!errors?.projectId}
                          disabled
                        >
                          <option value="">Select Project</option>
                          {projects.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.name}
                            </option>
                          ))}
                        </Form.Control>
                        {/* <Form.Control.Feedback type="invalid">{errors?.projectId}</Form.Control.Feedback> */}
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="formPurchaseOrder">
                        <Form.Label className="required">Purchase Order</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={purchaseOrderId}
                          // onChange={this.handlePurchaseOrderChange}
                          // isInvalid={!!errors?.purchaseOrderId}
                          disabled
                        >
                          <option value="">Select Purchase Order</option>
                          {purchaseOrders.map((po) => (
                            <option key={po.id} value={po.id}>
                              {po.poNumber}
                            </option>
                          ))}
                        </Form.Control>
                        {/* <Form.Control.Feedback type="invalid">{errors?.purchaseOrderId}</Form.Control.Feedback> */}
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="formPurchaseOrder">
                        <Form.Label className="required">PO Date</Form.Label>
                        <Form.Control type="text" value={poDate || 'N/A'} readOnly />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="formDcNumber">
                        <Form.Label className="required">DC Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="DC Number"
                          value={dcNumber}
                          // onChange={(e) => this.setState({ dcNumber: e.target.value })}
                          // isInvalid={!!errors?.dcNumber}
                          disabled
                        />
                        {/* <Form.Control.Feedback type="invalid">{errors?.dcNumber}</Form.Control.Feedback> */}
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="formDcDate">
                        <Form.Label className="required">DC Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={dcDate}
                          // onChange={(e) => this.setState({ dcDate: e.target.value })}
                          // isInvalid={!!errors?.dcDate}
                          disabled
                        />
                        {/* <Form.Control.Feedback type="invalid">{errors?.dcDate}</Form.Control.Feedback> */}
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5>Items</h5>

                  {poItems.map((item, index) => (

                    <Card key={index} className="mb-3">
                      <Card.Body>
                        <Row>
                          <Col md={1}>
                            <Form.Group controlId={`formItemName${index}`}>
                              <Form.Label>S.No</Form.Label>
                              {/* {console.log("item===>", item)} */}
                              <Form.Control type="text" value={item.serialNumber} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formItemName${index}`}>
                              <Form.Label>Item</Form.Label>
                              <Form.Control type="text" value={item.itemName} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formAskedQuantity${index}`}>
                              <Form.Label>PO Quantity</Form.Label>
                              <Form.Control type="number" value={item.askedQuantity} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formPendingQuantity${index}`}>
                              <Form.Label>Balance Quantity</Form.Label>
                              <Form.Control type="number" value={item.pendingQuantity} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={1}>
                            <Form.Group controlId={`formUom${index}`}>
                              <Form.Label>UOM</Form.Label>
                              <Form.Control type="text" value={item.uom} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formQuantity${index}`}>
                              <Form.Label>Ask Quantity</Form.Label>
                              <Form.Control
                                type="number"
                                value={item.quantity}
                                disabled
                              />
                              <Form.Control.Feedback type="invalid">{errors?.[`quantity_${index}`]}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formRemark${index}`}>
                              <Form.Label>Remark</Form.Label>
                              <Form.Control type="text" value={item.remark} readOnly placeholder="Enter Remark" />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  ))}
                </Form>
              </Card.Body>
            </Card>
          </div>
        </CommonLoader>
      </>
    );
  }
}
